import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService,
  IncomeTaxEntity,
  OpbouwHeffingskortingen, SpecificatieHeffingskortingen
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService  } from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {isNaN} from "mathjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-berekeningen-heffingskortingen',
  templateUrl: './heffingskortingen.component.html',
  styleUrls: ['./heffingskortingen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class HeffingskortingenBerekeningenComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;
    private partnerAangifte = {} as Aangifte;
    iackPartner = {} as number | 0;
    maximeringPartner= {} as number | 0;
    verhogingPartner = {} as number | 0;
    groeneBeleggingenPartner = {} as number | 0;
    specHeffingskortingenFormGroup = this.fb.group<AangifteRapport>({});
    specHeffingskortingen = {} as AangifteRapport;

    propertyNamesToCheck: string[] = [
        'algemeneHeffingskorting',
        'arbeidskorting',
        'inkomensafhankelijkeCombinatieKorting',
        'ouderenkorting',
        'alleenstaandeOuderenkorting',
        'wajong',
        'groeneBeleggingen',
        'levensloopverlof',
        'werkbonus',
        'vutkorting',
        'maximering',
        'verhogingPartner',
    ];

    propertyTextMap: Record<string, string> = {
        algemeneHeffingskorting: 'Algemene heffingskorting',
        arbeidskorting: 'Arbeidskorting',
        inkomensafhankelijkeCombinatieKorting: 'Inkomensafhankelijke combinatiekorting',
        ouderenkorting: 'Ouderenkorting',
        alleenstaandeOuderenkorting: 'Alleenstaande ouderenkorting',
        wajong: 'Jonggehandicaptenkorting',
        groeneBeleggingen: 'Korting voor groene beleggingen',
        levensloopverlof: 'Levensloopverlofkorting',
        werkbonus: 'Werkbonus',
        vutkorting: 'Vut-korting',
        maximering: 'Af: Maximering',
        verhogingPartner: 'Verhoging i.v.m. inkomen partner',
    };

    getPropertyValue(propertyName: string): number | null {
        const control = this.specHeffingskortingenFormGroup.get(['specificatieHeffingskortingen', 'opbouw', propertyName]);
        return control ? control.value : null;
    }

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specHeffingskortingenFormGroup = this.fb.group<AangifteRapport>(({
            specificatieHeffingskortingen: this.fb.group<SpecificatieHeffingskortingen>(({
                opbouw: this.fb.group<OpbouwHeffingskortingen>(({
                    algemeneHeffingskorting: null as unknown as number,
                    arbeidskorting: null as unknown as number,
                    inkomensafhankelijkeCombinatieKorting: null as unknown as number,
                    ouderenkorting: null as unknown as number,
                    alleenstaandeOuderenkorting: null as unknown as number,
                    wajong: null as unknown as number,
                    grondslagGroeneBeleggingen: null as unknown as number,
                    groeneBeleggingen: null as unknown as number,
                    levensloopverlof: null as unknown as number,
                    werkbonus: null as unknown as number,
                    vutkorting: null as unknown as number,
                    maximering: null as unknown as number,
                    verhogingPartner: null as unknown as number,
                    voldoetAanVoorwaardenUitbetalingAlgemeneHeffingskorting: '' as unknown as boolean,
                    voldoetAanVooraardenBijzondereVerhogingHeffingskorting: '' as unknown as boolean,
                } as OpbouwHeffingskortingen))
            } as SpecificatieHeffingskortingen))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        this.dataService.aangifteBerekening.subscribe((berekening) => {
            if (berekening.partnerBerekening?.heffingskortingen?.opbouw?.inkomensafhankelijkeCombinatieKorting) {
                this.iackPartner =berekening.partnerBerekening?.heffingskortingen?.opbouw?.inkomensafhankelijkeCombinatieKorting;
            } else {
                this.iackPartner = 0;
            }
            if (berekening.partnerBerekening?.heffingskortingen?.opbouw?.maximering) {
                this.maximeringPartner =berekening.partnerBerekening?.heffingskortingen?.opbouw?.maximering;
            } else {
                this.maximeringPartner = 0;
            }
            if (berekening.partnerBerekening?.heffingskortingen?.opbouw?.verhogingPartner) {
                this.verhogingPartner =berekening.partnerBerekening.heffingskortingen.opbouw.verhogingPartner;
            } else {
                this.verhogingPartner=0;
            }
            if (berekening.partnerBerekening?.heffingskortingen?.opbouw?.groeneBeleggingen) {
                this.groeneBeleggingenPartner =berekening.partnerBerekening.heffingskortingen.opbouw.groeneBeleggingen;
            } else {
                this.groeneBeleggingenPartner=0;
            }
        })
        this.partner.subscribe((partner) => {
            this.partnerBoolean = partner;
            this.specHeffingskortingenFormGroup.reset()
            if (partner) {
                this.dataService.partnerAangifteRapport.subscribe((value) => {
                    if (value.specificatieHeffingskortingen?.opbouw) {
                        value.specificatieHeffingskortingen.opbouw.inkomensafhankelijkeCombinatieKorting=this.iackPartner
                        value.specificatieHeffingskortingen.opbouw.maximering=this.maximeringPartner
                        value.specificatieHeffingskortingen.opbouw.verhogingPartner=this.verhogingPartner
                        value.specificatieHeffingskortingen.opbouw.groeneBeleggingen=this.groeneBeleggingenPartner
                    }
                    setTimeout(()=> {
                        this.specHeffingskortingen = value;
                        this.specHeffingskortingenFormGroup.patchValue(this.specHeffingskortingen)
                    },200)
                });
            } else {
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specHeffingskortingen = value;
                    this.specHeffingskortingenFormGroup.patchValue(this.specHeffingskortingen)
                });
            }
        })
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    protected readonly NaN = NaN;
    protected readonly isNaN = isNaN;
}

